import styled from 'styled-components';

const NewsletterText = styled.p`
  color: white;
  text-align: center;
  font-size: 1.8rem;
  line-height: 3rem;
  width: 90%;
  max-width: 600px;
  margin: 0 auto 2rem;
`;

export default NewsletterText;
